import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { UserData } from "src/app/_models/userData";
import { environment } from "src/environments/environment";

const AUTH_TOKEN_KEY: string = "authToken";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private httpClient: HttpClient) {}

  public usernameAndRole: UserData = new UserData();

  public login(): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "user/login");
  }

  public getAuthToken(): string {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  }

  public setAuthToken(username: string, password: string): string {
    let authTokenBase64 = btoa(username + ":" + password);
    localStorage.setItem("authToken", authTokenBase64);
    return localStorage.getItem(AUTH_TOKEN_KEY);
  }

  public removeToken(): void {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  }

  public logout(): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "user/logout");
  }
  
  public getUserInfo(): Observable<any> {

    const headers = new HttpHeaders({
      Authorization: this.getAuthToken()
    })

    console.warn("Here is the auth token: ", this.getAuthToken());

    return this.httpClient.get(environment.API_BASE_URL + "user/info", {headers: headers});
  }

  private userInfoSource = new BehaviorSubject<UserData>(null);
  userInfo$ = this.userInfoSource.asObservable();

  setUserInfo(userData: UserData): void {
    this.userInfoSource.next(userData);
  }
}
